import React, { useEffect, useRef, useState } from 'react';
import { confirmAdminEmailChange } from '../../utils/api';

const AdminVerifyEmailPage: React.FC = () => {
  const [state, setState] = useState<'loading'|'success'|'error'>('loading');
  const [error, setError] = useState<string>('');

  const called = useRef(false);

  useEffect(() => {
    if (called.current) return; // Guard for React StrictMode double-invoke in dev
    called.current = true;
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token') || '';
    if (!token) {
      setState('error');
      setError('トークンが無効です');
      return;
    }
    (async () => {
      try {
        const res = await confirmAdminEmailChange(token);
        if (res.success) {
          setState('success');
        } else {
          // Only set error if we haven't already succeeded
          setState((prev) => (prev === 'loading' ? 'error' : prev));
          setError((res as any).error || 'メール確認に失敗しました');
        }
      } catch (e: any) {
        // Only set error if we haven't already succeeded
        setState((prev) => (prev === 'loading' ? 'error' : prev));
        setError(e?.response?.data?.error || 'メール確認に失敗しました');
      }
    })();
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
      <img src="/logo/logo.svg" alt="Takagi Logo" style={{ width: 180, marginBottom: 16 }} />
      {state === 'loading' && <div>確認中...</div>}
      {state === 'success' && (
        <>
          <div style={{ color: '#2e7d32', fontWeight: 600, fontSize: 18 }}>メールアドレスを確認しました。</div>
          <a href="/admin/login" style={{ color: '#0077C8', textDecoration: 'none' }}>管理画面に戻る</a>
        </>
      )}
      {state === 'error' && (
        <>
          <div style={{ color: '#c62828', fontWeight: 600, fontSize: 18 }}>メール確認に失敗しました</div>
          <div style={{ color: '#555' }}>{error}</div>
          <a href="/admin/login" style={{ color: '#0077C8', textDecoration: 'none', marginTop: 8 }}>管理画面に戻る</a>
        </>
      )}
    </div>
  );
};

export default AdminVerifyEmailPage;
